export const Footer = () => (
  <footer className="border-t border-[#E6DFD5] py-14 bg-[#F3EFEA]/40" data-testid="footer">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <div className="flex flex-col md:flex-row md:items-start justify-between gap-8">
        <div>
          <p className="font-serif-display text-2xl font-semibold text-[#2C2A28]">
            Wicks <em className="italic text-[#8A5A44] font-medium">Marriage Ministries</em>
          </p>
          <p className="text-sm text-[#5C5854] font-light mt-3 max-w-sm leading-relaxed">
            Driving up the statistics of family marriages, one conversation at a time.
          </p>
        </div>
        <div className="text-sm text-[#5C5854] font-light space-y-2 md:text-right">
          <p>Greensboro, NC · Video calls nationwide</p>
          <p>
            <a
              href="mailto:wicksmarriageministries@gmail.com"
              className="hover:text-[#8A5A44] transition-colors duration-300"
            >
              wicksmarriageministries@gmail.com
            </a>
          </p>
        </div>
      </div>
      <div className="mt-12 pt-8 border-t border-[#E6DFD5]">
        <p className="text-xs text-[#5C5854]/80 leading-relaxed max-w-3xl" data-testid="footer-disclaimer">
          Wicks Marriage Ministries offers faith-based marriage <strong>coaching</strong>, not
          licensed counseling or therapy. If you are in crisis or need clinical care, please seek a
          licensed professional. © {new Date().getFullYear()} Wicks Marriage Ministries. Nonprofit
          status in progress.
        </p>
      </div>
    </div>
  </footer>
);
